import {UserId} from '@legit-health/ui';
import {useSuspensePatient} from '@/practitioner/hooks/patient/usePatient';
import {
  ImageProtocolCaptureContent,
  ImageProtocolCaptureResult
} from '@/shared/views/imageProtocol/ImageProtocolCaptureModal';

interface PractitionerImageProtocolCaptureContentProps {
  patientId: UserId;
  onComplete: (result: ImageProtocolCaptureResult) => void;
}

export default function PractitionerImageProtocolCaptureContent({
  patientId,
  onComplete
}: PractitionerImageProtocolCaptureContentProps) {
  const patient = useSuspensePatient(patientId);
  return (
    <ImageProtocolCaptureContent
      patientId={patientId}
      assignedPathologies={patient.assignedPathologies}
      onComplete={onComplete}
    />
  );
}
